import TableDailyDemandReport from './TableDailyDemandReport';

export default TableDailyDemandReport;
export { TableDailyDemandReport };
